module.exports = __webpack_public_path__ + "assets/img/DS-room3 (2).a74ff1a1.jpg";